/* THW staging collection filtering v3. Native app.js is not modified. */
(function () {
  'use strict';
  if (!document.querySelector('.collection-main-section') || window.THWCollectionFiltersInitialized) return;
  window.THWCollectionFiltersInitialized = true;

  var original = new URLSearchParams(window.location.search);
  var pending = new URLSearchParams(window.location.search);
  function isFilterKey(key) { return key && key.indexOf('filter.') === 0; }
  // Shopify accepts repeated parameters for multiple values in the same filter.
  // Also read legacy comma-separated URLs for compatibility.
  function getValues(params, key) {
    var result = [];
    params.getAll(key).forEach(function (entry) {
      entry.split(',').forEach(function (part) {
        var value = part.trim();
        if (value && result.indexOf(value) === -1) result.push(value);
      });
    });
    return result;
  }
  function setValues(key, values) {
    // One parameter per value (official Shopify storefront filtering format).
    // This avoids encoding the comma separator as %2C, which can be
    // interpreted inconsistently by custom/tag/group filters.
    pending.delete(key);
    values.forEach(function (value) { pending.append(key, value); });
  }
  function isSelected(key, value) { return getValues(pending, key).indexOf(value) !== -1; }
  function toggleValue(key, value) {
    var values = getValues(pending, key);
    var i = values.indexOf(value);
    if (i === -1) values.push(value);
    else values.splice(i, 1);
    setValues(key, values);
  }
  function signature(params) {
    var keys = [];
    params.forEach(function (_value, key) {
      if (isFilterKey(key) && keys.indexOf(key) < 0) keys.push(key);
    });
    return keys.sort().map(function (key) {
      var value = key.indexOf('filter.v.price.') === 0 || key.indexOf('filter.p.price.') === 0
        ? params.get(key) : getValues(params, key).sort().join(',');
      return value ? key + '=' + value : '';
    }).filter(Boolean).join('&');
  }
  function changed() { return signature(original) !== signature(pending); }
  function countSelected() {
    var count = 0, seen = [];
    pending.forEach(function (_value, key) {
      if (!isFilterKey(key) || seen.indexOf(key) >= 0) return;
      seen.push(key);
      count += getValues(pending, key).length;
    });
    return count;
  }
  function syncUI() {
    document.querySelectorAll('.thw-filter-group [data-filter-input][data-name][data-value]').forEach(function (link) {
      var selected = isSelected(link.dataset.name, link.dataset.value);
      link.classList.toggle('thw-pending-filter', selected);
      link.setAttribute('role', 'checkbox');
      link.setAttribute('aria-checked', selected ? 'true' : 'false');
      var check = link.querySelector('[data-filter-checkbox]');
      if (check) {
        if (selected) check.setAttribute('data-filter-checked', '');
        else check.removeAttribute('data-filter-checked');
      }
    });
    var count = countSelected();
    document.querySelectorAll('[data-thw-apply-filters]').forEach(function (button) {
      button.textContent = count ? 'Apply filters (' + count + ')' : 'Apply filters';
      button.disabled = !changed();
    });
    document.querySelectorAll('[data-thw-size-filter]').forEach(function (pill) {
      var selected = isSelected(pill.dataset.name, pill.dataset.value);
      pill.classList.toggle('is-active', selected);
      pill.classList.toggle('thw-size-pending', selected);
    });
  }
  function serializeFilterQuery(params) {
    // Normalize legacy comma-separated filter parameters to repeated keys.
    // Leave price-range fields and unrelated URL parameters untouched.
    var result = new URLSearchParams();
    var usedFilters = [];
    params.forEach(function (value, key) {
      if (!isFilterKey(key) || key.indexOf('filter.v.price.') === 0 || key.indexOf('filter.p.price.') === 0) {
        result.append(key, value);
      } else if (usedFilters.indexOf(key) === -1) {
        usedFilters.push(key);
        getValues(params, key).forEach(function (item) { result.append(key, item); });
      }
    });
    return result.toString();
  }
  function apply() {
    pending.delete('page');
    var query = serializeFilterQuery(pending);
    window.location.assign(window.location.pathname + (query ? '?' + query : ''));
  }
  function capturePrice(input) {
    if (!isFilterKey(input.name)) return;
    var value = input.value.trim();
    if (value === '') pending.delete(input.name);
    else pending.set(input.name, value);
    syncUI();
  }
  // Mobile: show the existing filter panel in our own sheet, not Fancybox.
  // Parallax opens Fancybox around this same hidden panel; its positioning and
  // scroll rules conflict with the collection UI and can render a white screen.
  var mobileOverlay = null;
  var panelRestorePoint = null;
  var previousFocus = null;
  var lockedScrollY = 0;
  var previousBodyStyles = null;

  function openMobileFilters(button) {
    if (window.innerWidth >= 799 || mobileOverlay) return false;
    var panel = document.querySelector('.collection-main-section [data-filter-modal]');
    if (!panel || !panel.parentNode) return false;

    var overlay = document.createElement('div');
    overlay.className = 'thw-mobile-filter-overlay';
    overlay.setAttribute('data-thw-mobile-overlay', '');
    overlay.innerHTML =
      '<div class="thw-mobile-filter-backdrop" data-thw-filter-close aria-hidden="true"></div>' +
      '<div class="collection-main-section thw-mobile-filter-sheet" role="dialog" aria-modal="true" aria-label="Filters" tabindex="-1">' +
        '<div class="thw-mobile-filter-header">' +
          '<h2 class="thw-mobile-filter-title">Filters</h2>' +
          '<button type="button" class="thw-mobile-filter-close" data-thw-filter-close aria-label="Close filters">' +
            '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">' +
              '<path d="M5 5l14 14M19 5L5 19"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
      '</div>';

    var sheet = overlay.querySelector('.thw-mobile-filter-sheet');
    var marker = document.createComment('THW mobile filter original location');
    panel.parentNode.insertBefore(marker, panel);
    panelRestorePoint = marker;
    previousFocus = button || document.activeElement;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    previousBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };

    // Move, never clone: preserve the actual checkbox and price inputs.
    sheet.appendChild(panel);
    document.body.appendChild(overlay);
    mobileOverlay = overlay;
    document.body.classList.add('thw-mobile-filters-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    syncUI();
    overlay.querySelector('.thw-mobile-filter-close').focus({ preventScroll: true });
    return true;
  }

  function closeMobileFilters() {
    if (!mobileOverlay) return;
    var panel = mobileOverlay.querySelector('[data-filter-modal]');
    if (panel && panelRestorePoint && panelRestorePoint.parentNode) {
      panelRestorePoint.parentNode.insertBefore(panel, panelRestorePoint);
      panelRestorePoint.remove();
    }
    panelRestorePoint = null;
    mobileOverlay.remove();
    mobileOverlay = null;
    document.body.classList.remove('thw-mobile-filters-open');
    if (previousBodyStyles) {
      Object.keys(previousBodyStyles).forEach(function (key) {
        document.body.style[key] = previousBodyStyles[key];
      });
    }
    window.scrollTo(0, lockedScrollY);
    if (previousFocus && previousFocus.isConnected && previousFocus.focus) {
      previousFocus.focus({ preventScroll: true });
    }
    previousFocus = null;
    previousBodyStyles = null;
    syncUI();
  }

  // Capture only the collection's mobile open control before Parallax's
  // direct jQuery click listener has a chance to invoke Fancybox.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var close = event.target.closest('[data-thw-filter-close]');
    if (close && mobileOverlay && mobileOverlay.contains(close)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMobileFilters();
      return;
    }
    var open = event.target.closest('.collection-main-section [data-filter-modal-open]');
    if (open && window.innerWidth < 799) {
      // Only suppress the theme's modal if ours was actually constructed.
      if (openMobileFilters(open)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!mobileOverlay) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMobileFilters();
    } else if (event.key === 'Tab') {
      var tabbable = Array.prototype.slice.call(
        mobileOverlay.querySelectorAll('button:not([disabled]), a[href]:not([aria-disabled="true"]), input:not([disabled]), select:not([disabled])')
      ).filter(function (node) {
        return node.getClientRects().length > 0;
      });
      if (!tabbable.length) return;
      var first = tabbable[0];
      var last = tabbable[tabbable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !mobileOverlay.contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }
  }, true);
  window.addEventListener('resize', function () {
    if (mobileOverlay && window.innerWidth >= 799) closeMobileFilters();
  });

  // Capture before jQuery/direct listeners from Parallax, avoiding immediate navigation.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var control = event.target.closest('[data-thw-filter-toggle]');
    if (control && control.closest('.thw-filter-group')) {
      event.preventDefault(); event.stopImmediatePropagation();
      var group = control.closest('.thw-filter-group');
      var open = group.classList.toggle('is-open');
      control.setAttribute('aria-expanded', String(open));
      group.querySelectorAll('[data-filter-group-list]').forEach(function (list) {
        list.setAttribute('aria-expanded', String(open));
      });
      return;
    }
    control = event.target.closest('.thw-filter-group [data-filter-input][data-name][data-value]');
    if (control) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (control.hasAttribute('data-disabled') || !isFilterKey(control.dataset.name)) return;
      toggleValue(control.dataset.name, control.dataset.value);
      syncUI();
      return;
    }
    control = event.target.closest('.thw-filter-group [data-range-filter-button]');
    if (control) {
      event.preventDefault(); event.stopImmediatePropagation();
      var form = control.closest('form');
      if (form) form.querySelectorAll('[data-filter-range]').forEach(capturePrice);
      return;
    }
    control = event.target.closest('[data-thw-apply-filters]');
    if (control) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (changed()) apply();
      return;
    }
    control = event.target.closest('[data-thw-size-filter][data-name][data-value]');
    if (control && changed()) {
      event.preventDefault(); event.stopImmediatePropagation();
      toggleValue(control.dataset.name, control.dataset.value);
      apply();
      return;
    }
    control = event.target.closest('[data-thw-size-clear][data-name]');
    if (control && changed()) {
      event.preventDefault(); event.stopImmediatePropagation();
      pending.delete(control.dataset.name);
      apply();
    }
  }, true);
  document.addEventListener('input', function (event) {
    if (event.target instanceof HTMLInputElement && event.target.matches('.thw-filter-group [data-filter-range]')) {
      capturePrice(event.target);
    }
  }, true);
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (select && select.id === 'sort-by' && changed()) {
      event.preventDefault(); event.stopImmediatePropagation();
      pending.set('sort_by', select.value);
      apply();
    }
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === ' ' && event.target && event.target.matches &&
        event.target.matches('.thw-filter-group [data-filter-input]')) {
      event.preventDefault(); event.target.click();
    }
  }, true);
  function init() {
    syncUI();
    // Keep the original Grid/List handler and synchronize both visual copies.
    var controls = document.querySelectorAll('.collection-filter-view-type');
    if (controls.length && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        var active = document.querySelector('.collection-filter-view-type.active');
        if (!active) return;
        var type = active.dataset.type;
        controls.forEach(function (button) {
          var selected = button.dataset.type === type;
          if (button.classList.contains('active') !== selected) button.classList.toggle('active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      });
      controls.forEach(function (button) {
        observer.observe(button, { attributes: true, attributeFilter: ['class'] });
        button.setAttribute('aria-pressed', String(button.classList.contains('active')));
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
